import { get } from 'lodash'

import { DenominationResource, Manifestation, MaterialResource, MeasurementResource, TechniqueResource, TypedTextResource, getTranslatedString } from '@skinsoft/types'

export const id = (manifestation: Manifestation) => get(manifestation, 'id');

export const expression = (manifestation: Manifestation) => {
    return get(manifestation, ['linkToExpression', 'referentExpression', 'ref']) ??
        get(manifestation, ['linkToExpression', 'referentExpression']) 
}

export const title = (manifestation: Manifestation, locale: string) => getTranslatedString(get(manifestation, 'descriptionSchema.titles[0].title'), locale)

export const domains = (manifestation: Manifestation): string[] | undefined | null => {
    return get(manifestation, 'descriptionSchema.domain')
}

export const domain = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.domain[0]')

export const name = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.name[0]')

export const denominations = (manifestation: Manifestation): DenominationResource[] | undefined | null => {
    return get(manifestation, 'descriptionSchema.denominations')
}

export const descriptions = (manifestation: Manifestation): TypedTextResource[] => {
    return get(manifestation, 'descriptionSchema.descriptions', [])
}

export const firstDescription = (manifestation: Manifestation): TypedTextResource | undefined => {
    return get(manifestation, 'descriptionSchema.descriptions[0]')
}

export const materialsAndTechnics = (manifestation: Manifestation) => get(manifestation, 'descriptionSchema.materialAndTechniques')

export const materials = (manifestation: Manifestation): MaterialResource[] => {
    const materials = get(manifestation, 'descriptionSchema.materialAndTechniques[0].materials')

    if(materials) {
        return materials
    }

    return []
}

export const techniques = (manifestation: Manifestation): TechniqueResource[] => {
    const techniques = get(manifestation, 'descriptionSchema.materialAndTechniques[0].techniques')

    if(techniques) {
        return techniques
    }

    return []
}

export const measurements = (manifestation: Manifestation): MeasurementResource[] => {
    return get(manifestation, 'descriptionSchema.measurements')
}